import { createSlice } from "@reduxjs/toolkit";

export const characterSlice = createSlice({
  name: "character",
  initialState: {
    activeCharacter: null,
    character: null,
  },
  reducers: {
    characterLogout: (state) => {
      state.character = null;
      state.activeCharacter = null;
    },
    changeCharacterName: (state, action) => {
      state.character.character.characterName = action.payload;
    },
    changeCritEmote: (state, action) => {
      state.character.character.critEmote = action.payload;
    },
    changeCritFailEmote: (state, action) => {
      state.character.character.critFailEmote = action.payload;
    },
    changeCharacterPortrait: (state, action) => {
      state.character.character.characterPortrait = action.payload;
    },
    changeCharacterBanner: (state, action) => {
      state.character.character.characterBanner = action.payload;
    },
    changeCharacterMacro: (state, action) => {
      state.character.character.macroIcon1 = action.payload;
    },
    changeMacro1: (state, action) => {
      state.character.character.macro1 = action.payload;
    },
    changeMacro2: (state, action) => {
      state.character.character.macro2 = action.payload;
    },
    changeMacro3: (state, action) => {
      state.character.character.macro3 = action.payload;
    },
    setActiveCharacter: (state, action) => {
        state.activeCharacter = action.payload;
     },
     setCharacter: (state, action) => {
      state.character = action.payload;
   },
  },
});

export const {
  setCharacter,
  characterLogout,
  setActiveCharacter,
  changeCharacterName,
  changeCritEmote,
  changeCritFailEmote,
  changeCharacterPortrait,
  changeCharacterBanner,
  changeCharacterMacro,
  changeMacro1,
  changeMacro2,
  changeMacro3,
} = characterSlice.actions;

export const selectCharacter = (state) => state.character;
export default characterSlice.reducer;
